(function () {
  function getPinSizeMap(form) {
    var mapEl = form.querySelector('[data-prx-pin-size-map]');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent);
    } catch (e) {
      return {};
    }
  }

  function initForm(form) {
    var input = form.querySelector('[data-prx-pin-size-input]');
    if (!input || form.dataset.prxPinSizeBound) return;
    form.dataset.prxPinSizeBound = 'true';

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var pinSizeMap = getPinSizeMap(form);
      var pinSize = pinSizeMap[variant.id] || '';

      input.value = pinSize;
      input.disabled = !pinSize;
    });
  }

  document.querySelectorAll('form').forEach(function (form) {
    if (form.querySelector('[data-prx-pin-size-input]')) initForm(form);
  });
})();
